export const downloadFile = (url) => {
  if (!url) return;
  let secureUrl = url;
  if (window.location.protocol === "https:" && url.startsWith("http:")) {
    secureUrl = url.replace("http:", "https:");
  }
  window.location.href = secureUrl;
};
